var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "rating list-item-feature" }, [
    _c("div", { staticClass: "title" }, [_vm._v("Ranking")]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "rating-content" },
      [
        _vm.calling
          ? _c("Loading", { attrs: { inline: "", small: "" } })
          : [
              _vm._l(_vm.ratings, function(loopRating) {
                return _c(
                  "span",
                  { key: "rating" + loopRating, staticClass: "rating-star" },
                  [
                    _vm.rating === loopRating || _vm.calling
                      ? _c(
                          "span",
                          [
                            _c("Icon", {
                              attrs: {
                                icon:
                                  _vm.rating >= loopRating
                                    ? "star-filled"
                                    : "star"
                              }
                            })
                          ],
                          1
                        )
                      : _c(
                          "a",
                          {
                            attrs: { href: "#" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.save(loopRating)
                              }
                            }
                          },
                          [
                            _c("Icon", {
                              attrs: {
                                icon:
                                  _vm.rating >= loopRating
                                    ? "star-filled"
                                    : "star"
                              }
                            })
                          ],
                          1
                        )
                  ]
                )
              }),
              _vm._v(" "),
              _vm.lastModificationTimeStamp
                ? _c("span", { staticClass: "last-modification-time-stamp" }, [
                    _vm._v(
                      "\n\t\t\t\t" +
                        _vm._s(_vm._f("date")(_vm.lastModificationTimeStamp)) +
                        "\n\t\t\t"
                    )
                  ])
                : _vm._e()
            ]
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }